import i18n from '../i18n';
import { LINK_PROD, LANG, HOST_URL, CORPORATE_PATH, CAREER_PATH } from './config';
import tr from './site/tr.json';
import en from './site/en.json';
import ru from './site/ru.json';
const configList = { tr, en, ru };
/**
 * Site ile alakali olan constantlari buraya ekliyoruz.
 * Bu constantlari seo, meta vs icin kullanabilirsiniz.
 */
export const defaultPageTitle = i18n.messages[LANG].meta?.title;
export const title = 'Onedio';
// eslint-disable-next-line prettier/prettier
export const description = i18n.messages[LANG].meta?.description;

// apps
export const applicationName = 'Onedio';
export const itunesAppId = configList[LANG].itunesAppId;

// services
export const fbAppId = configList[LANG].fbAppId;
export const fbPages1 = configList[LANG].fbPages1;
export const fbPages2 = configList[LANG].fbPages2;
export const yandexVerification = '9453965133cadd78';

// url
export const twitterRedirectUrl = 'https://api.twitter.com/oauth/authenticate';

// opengraph + twitter
export const ogMeta = {
  title: i18n.messages[LANG].meta?.title,
  description,
  type: 'website',
  domain: 'onedio.com',
  url: LINK_PROD,
  imageUrl: 'https://proj-assets.onedio.com/onediologo.jpg',
};

// user
export const PASSIVE_USER = i18n.messages[LANG].profile?.['passive-user'];
// LOG
export const CAREER_LOG = `
 ██████╗ ███╗   ██╗███████╗██████╗ ██╗ ██████╗ 
██╔═══██╗████╗  ██║██╔════╝██╔══██╗██║██╔═══██╗
██║   ██║██╔██╗ ██║█████╗  ██║  ██║██║██║   ██║
██║   ██║██║╚██╗██║██╔══╝  ██║  ██║██║██║   ██║
╚██████╔╝██║ ╚████║███████╗██████╔╝██║╚██████╔╝
 ╚═════╝ ╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝ ╚═════╝ 
\n
${i18n.messages[LANG].main?.['career-question']}
${HOST_URL}/${CORPORATE_PATH}/${CAREER_PATH}`;
